// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1249":"c9588d985249cacf","6698":"03ac22611f34d1af"}[chunkId] + ".js";
};